export class UserInfo {
  isAuthenticated: boolean;
  userName: string;
  userID: number;
  fullName: string;
};